declare global {
  interface Window {
    OnetrustActiveGroups?: string;
  }
}

export const getConsentCategoryIds = () => window.OnetrustActiveGroups;
